import { render, staticRenderFns } from "./Alteracao.vue?vue&type=template&id=1ea6ca7b"
import script from "./Alteracao.vue?vue&type=script&lang=js"
export * from "./Alteracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports